import { LoginPanelSwitcher } from './LoginPanelSwitcher';

export function LoginShell({
  children,
  eyebrow = 'WorkTrack System',
  title = 'Work Track System',
  copy = '',
  activePanel
}) {
  return (
    <main className="login-screen">
      <section className="login-card">
        <div className="login-card__brand">
          <img src="/worktrack-logo.png" alt="WorkTrack System" className="login-card__logo" />
          <div>
            {eyebrow && <div className="login-card__eyebrow">{eyebrow}</div>}
            <h1 className="login-card__title">{title}</h1>
          </div>
        </div>

        <LoginPanelSwitcher active={activePanel} />

        {copy && <p className="login-card__copy">{copy}</p>}

        {children}
      </section>
    </main>
  );
}
